import { render, staticRenderFns } from "./HeaderItem.vue?vue&type=template&id=83c917d8&scoped=true"
import script from "./HeaderItem.vue?vue&type=script&lang=js"
export * from "./HeaderItem.vue?vue&type=script&lang=js"
import style0 from "./HeaderItem.vue?vue&type=style&index=0&id=83c917d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c917d8",
  null
  
)

export default component.exports